import React, { createContext, useContext, useState } from 'react';

const CasePaginationContext = createContext();

export const useCasePagination = () => {
  const context = useContext(CasePaginationContext);
  if (!context) {
    throw new Error('useCasePagination must be used within CasePaginationProvider');
  }
  return context;
};

export const CasePaginationProvider = ({ children }) => {
  const [paginationData, setPaginationData] = useState({
    courtRefs: [],
    currentIndex: -1,
    totalCases: 0,
    caseType: '',
    isLoading: false,
  });

  const updatePaginationData = (data) => {
    setPaginationData(prev => ({ ...prev, ...data }));
  };

  const resetPaginationData = () => {
    setPaginationData({
      courtRefs: [],
      currentIndex: -1,
      totalCases: 0,
      caseType: '',
      isLoading: false,
    });
  };

  return (
    <CasePaginationContext.Provider
      value={{
        paginationData,
        updatePaginationData,
        resetPaginationData,
      }}
    >
      {children}
    </CasePaginationContext.Provider>
  );
};